import { NotificationInfoItem } from '@doda/common/src/interfaces/api/notificationInfo';
import { LocalStorageUtil } from '@doda/common/src/utils/localStorageUtil';

const COUNSELING_ANNOUNCEMENT_INFO_TYPE: string = 'counselingAnnouncement';

/**
 * お知らせ_カウンセリング予約訴求データ取得(SP)
 * @param {NotificationInfoItem[]} notificationInfoList - お知らせ情報のリスト
 * @param {boolean} counselingShow - カウンセリング予約可否判定APIの結果
 * @param {string} web2NotificationCounselingAbGroupNo - AB振分けグループNo
 * @returns {Promise<NotificationInfoItem[]>} - 更新されたお知らせ情報のリスト
 */
export const getCounselingAnnouncementInfoSP = async (
  notificationInfoList: NotificationInfoItem[],
  counselingShow: boolean = false,
  web2NotificationCounselingAbGroupNo?: string
) => {
  const counselingExcludedList: NotificationInfoItem[] =
    notificationInfoList.filter(
      (item) => item.infoType !== COUNSELING_ANNOUNCEMENT_INFO_TYPE
    );
  if (!counselingShow) {
    return counselingExcludedList;
  }

  // テストユーザの場合はカウンセリング予約訴求を追加
  if (web2NotificationCounselingAbGroupNo?.toString() === '2') {
    const now = new Date();
    const counselingAnnouncementInfo: NotificationInfoItem[] = [
      {
        category: '999',
        entryDate: `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()} ${now.getHours()}:${now.getMinutes()}`,
        infoType: COUNSELING_ANNOUNCEMENT_INFO_TYPE,
        judge: '',
        readedFlg: true,
        sortNum: 0,
        text: '',
        url: '/dcfront/counseling/reserveDate/',
      },
    ];
    return [...counselingAnnouncementInfo, ...counselingExcludedList];
  }

  return counselingExcludedList;
};

/**
 * お知らせ_カウンセリング予約訴求データ取得(PC)
 * @param {boolean} counselingShow - カウンセリング予約可否判定APIの結果
 * @param {string | number} web2NotificationCounselingAbGroupNo - AB振分けグループNo
 * @returns {Promise<NotificationInfoItem[]>} - 更新されたお知らせ情報のリスト
 */
export const getCounselingAnnouncementInfoPC = async (
  counselingShow: boolean,
  web2NotificationCounselingAbGroupNo?: string | number
) => {
  let notificationInfoList: NotificationInfoItem[] = []; // 処理用リスト

  const savedInfo = LocalStorageUtil.getItem('header_notificationInfoList');
  if (savedInfo) {
    notificationInfoList = savedInfo as NotificationInfoItem[];
  }

  const counselingExcludedList: NotificationInfoItem[] =
    notificationInfoList.filter(
      (item) => item.infoType !== COUNSELING_ANNOUNCEMENT_INFO_TYPE
    );
  if (!counselingShow) {
    if (counselingExcludedList.length > 0) {
      LocalStorageUtil.setItem(
        'header_notificationInfoList',
        counselingExcludedList
      );
    } else {
      LocalStorageUtil.removeItem('header_notificationInfoList');
    }
    return counselingExcludedList;
  }

  // テストユーザの場合はカウンセリング予約訴求を追加
  if (web2NotificationCounselingAbGroupNo?.toString() === '2') {
    const now = new Date();
    const counselingAnnouncementInfo: NotificationInfoItem[] = [
      {
        category: '999',
        entryDate: `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()} ${now.getHours()}:${now.getMinutes()}`,
        infoType: COUNSELING_ANNOUNCEMENT_INFO_TYPE,
        judge: '',
        readedFlg: true,
        sortNum: 0,
        text: '',
        url: '/dcfront/counseling/reserveDate/',
      },
    ];
    const notificationInfoStorageList: NotificationInfoItem[] = [
      ...counselingAnnouncementInfo,
      ...counselingExcludedList,
    ];
    LocalStorageUtil.setItem(
      'header_notificationInfoList',
      notificationInfoStorageList
    );
    return notificationInfoStorageList;
  }

  return counselingExcludedList;
};
